type Props = {
  icon: string;
  label: string;
  value: string;
  tone?: 'primary' | 'success' | 'danger' | 'warning' | 'info' | 'dark';
  hint?: string;
};

export function StatTile({ icon, label, value, tone = 'primary', hint }: Props) {
  return (
    <div className={`stat-tile stat-tile--${tone}`}>
      <div className="stat-tile__icon">
        <i className={`bi ${icon}`} />
      </div>
      <p className="stat-tile__value">{value}</p>
      <p className="stat-tile__label">{label}</p>
      {hint ? (
        <p className="stat-tile__label" style={{ opacity: 0.75, fontSize: '0.75rem' }}>
          {hint}
        </p>
      ) : null}
    </div>
  );
}
